module.exports = {
	"account.block": "Block @{name}",
	"account.block_domain": "Hide everything from {domain}",
	"account.disclaimer_full": "Information below may reflect the user's profile incompletely.",
	"account.edit_profile": "Edit profile",
	"account.follow": "Follow",
	"account.followers": "Followers",
	"account.follows": "Follows",
	"account.follows_you": "Follows you",
	"account.media": "Media",
	"account.mention": "Target @{name}",
	"account.mute": "Mute @{name}",
	"account.posts": "Posts",
	"account.report": "Report @{name}",
	"account.requested": "Awaiting approval. Click to cancel follow request",
	"account.share": "Share @{name}'s profile",
	"account.unblock": "Unblock @{name}",
	"account.unblock_domain": "Unhide {domain}",
	"account.unfollow": "Unfollow",
	"account.unmute": "Unmute @{name}",
	"account.view_full_profile": "View full profile",
	"boost_modal.combo": "You can press {combo} to skip this next time",
	"bundle_column_error.body": "Something went wrong while loading this component.",
	"bundle_column_error.retry": "Try again",
	"bundle_column_error.title": "Network error",
	"bundle_modal_error.close": "Close",
	"bundle_modal_error.message": "Something went wrong while loading this component.",
	"bundle_modal_error.retry": "Try again",
	"column.blocks": "/etc/block",
	"column.community": "~/www",
	"column.direct": "/var/spool/mail",
	"column.favourites": "/var/less-than-three",
	"column.follow_requests": "/var/requests",
	"column.home": "~",
	"column.mutes": "/etc/mute",
	"column.notifications": "/var/log/messages",
	"column.pins": "/var/pin",
	"column.public": "/var/www",
	"column_back_button.label": "..",
	"column_header.hide_settings": "Hide settings",
	"column_header.moveLeft_settings": "Move column to the left",
	"column_header.moveRight_settings": "Move column to the right",
	"column_header.pin": "Pin",
	"column_header.show_settings": "Show settings",
	"column_header.unpin": "Unpin",
	"column_subheading.navigation": "Navigation",
	"column_subheading.settings": "Settings",
	"compose_form.lock_disclaimer": "[[ This shouldn't be displayed. ]]",
	"compose_form.lock_disclaimer.lock": "locked",
	"compose_form.monologuing": "Monologue mode",
	"compose_form.monologuing_on": "Monologuing is on.",
	"compose_form.placeholder": "Input command.",
	"compose_form.privacy_disclaimer": "[[ This shouldn't be displayed. ]]",
	"compose_form.publish": "$exec",
	"compose_form.publish_loud": "$EXEC",
	"compose_form.sensitive": "Mark media as sensitive",
	"compose_form.spoiler": "Hide text behind warning",
	"compose_form.spoiler_placeholder": "Write your warning here",
	"confirmation_modal.cancel": "Cancel",
	"confirmations.block.confirm": "Block",
	"confirmations.block.message": "Are you sure you want to block {name}?",
	"confirmations.delete.confirm": "Delete",
	"confirmations.delete.message": "Are you sure you want to delete this status?",
	"confirmations.domain_block.confirm": "Hide entire domain",
	"confirmations.domain_block.message": "Are you really, really sure you want to block the entire {domain}? In most cases a few targeted blocks or mutes are sufficient and preferable.",
	"confirmations.mute.confirm": "Mute",
	"confirmations.mute.message": "Are you sure you want to mute {name}?",
	"confirmations.unfollow.confirm": "Unfollow",
	"confirmations.unfollow.message": "Are you sure you want to unfollow {name}?",
	"embed.instructions": "Embed this status on your website by copying the code below.",
	"embed.preview": "Here is what it will look like:",
	"emoji_button.activity": "Activity",
	"emoji_button.flags": "Flags",
	"emoji_button.food": "Food & Drink",
	"emoji_button.label": "Insert emoji",
	"emoji_button.nature": "Nature",
	"emoji_button.objects": "Objects",
	"emoji_button.people": "People",
	"emoji_button.search": "Search...",
	"emoji_button.symbols": "Symbols",
	"emoji_button.travel": "Travel & Places",
	"empty_column.community": "The local timeline is empty. Write something publicly to get the ball rolling!",
	"empty_column.direct": "You don't have any direct messages yet. When you send or receive one, it will show up here.",
	"empty_column.hashtag": "There is nothing in this hashtag yet.",
	"empty_column.home": "You aren't following anyone yet. Visit {public} or use search to get started and meet other users.",
	"empty_column.home.inactivity": "Your home feed is empty. If you have been inactive for a while, it will be regenerated for you soon.",
	"empty_column.home.public_timeline": "the public timeline",
	"empty_column.notifications": "You don't have any notifications yet. Interact with others to start the conversation.",
	"empty_column.public": "There is nothing here! Write something publicly, or manually follow users from other instances to fill it up",
	"follow_request.authorize": "Authorize",
	"follow_request.reject": "Reject",
	"getting_started.appsshort": "Apps",
	"getting_started.faq": "FAQ",
	"getting_started.heading": "/dev/null",
	"getting_started.open_source_notice": "Mastodon is open source software. You can contribute or report issues on GitHub at {github}.",
	"getting_started.userguide": "User Guide",
	"home.column_settings.advanced": "Advanced",
	"home.column_settings.basic": "Basic",
	"home.column_settings.filter_regex": "Filter out by regular expressions",
	"home.column_settings.show_reblogs": "Show reruns",
	"home.column_settings.show_replies": "Show replies",
	"home.settings": "Column settings",
	"lightbox.close": "Close",
	"lightbox.next": "Next",
	"lightbox.previous": "Previous",
	"loading_indicator.label": "Loading...",
	"media_gallery.toggle_visible": "Toggle visibility",
	"missing_indicator.label": "Not found",
	"navigation_bar.blocks": "Blocked users",
	"navigation_bar.community_timeline": "Local timeline",
	"navigation_bar.direct": "Direct messages",
	"navigation_bar.edit_profile": "Edit profile",
	"navigation_bar.favourites": "Saved",
	"navigation_bar.follow_requests": "Follow requests",
	"navigation_bar.info": "About this instance",
	"navigation_bar.logout": "Logout",
	"navigation_bar.mutes": "Muted users",
	"navigation_bar.pins": "Pinned commands",
	"navigation_bar.preferences": "Preferences",
	"navigation_bar.public_timeline": "Federated timeline",
	"notification.favourite": "{name} saved your command",
	"notification.follow": "{name} followed you",
	"notification.mention": "{name} targeted you",
	"notification.reblog": "{name} reran your command",
	"notifications.clear": "Clear notifications",
	"notifications.clear_confirmation": "Are you sure you want to permanently clear all your notifications?",
	"notifications.column_settings.alert": "Desktop notifications",
	"notifications.column_settings.favourite": "Saved commands:",
	"notifications.column_settings.follow": "New followers:",
	"notifications.column_settings.mention": "Targets:",
	"notifications.column_settings.push": "Push notifications",
	"notifications.column_settings.push_meta": "This device",
	"notifications.column_settings.reblog": "Reran commands:",
	"notifications.column_settings.show": "Show in column",
	"notifications.column_settings.sound": "Play sound",
	"onboarding.done": "Done",
	"onboarding.next": "Next",
	"onboarding.page_five.public_timelines": "The local timeline shows public posts from everyone on {domain}. The federated timeline shows public posts from everyone who people on {domain} follow. These are the Public Timelines, a great way to discover new people.",
	"onboarding.page_four.home": "The home timeline shows posts from people you follow.",
	"onboarding.page_four.notifications": "The notifications column shows when someone interacts with you.",
	"onboarding.page_one.federation": "Mastodon is a network of independent servers joining up to make one larger social network. We call these servers instances.",
	"onboarding.page_one.handle": "You are on {domain}, so your full handle is {handle}",
	"onboarding.page_one.welcome": "Welcome to Mastodon!",
	"onboarding.page_six.admin": "Your instance's admin is {admin}.",
	"onboarding.page_six.almost_done": "Almost done...",
	"onboarding.page_six.appetoot": "Bon Appetoot!",
	"onboarding.page_six.apps_available": "There are {apps} available for iOS, Android and other platforms.",
	"onboarding.page_six.github": "Mastodon is free open-source software. You can report bugs, request features, or contribute to the code on {github}.",
	"onboarding.page_six.guidelines": "community guidelines",
	"onboarding.page_six.read_guidelines": "Please read {domain}'s {guidelines}!",
	"onboarding.page_six.various_app": "mobile apps",
	"onboarding.page_three.profile": "Edit your profile to change your avatar, bio, and display name. There, you will also find other preferences.",
	"onboarding.page_three.search": "Use the search bar to find people and look at hashtags, such as {illustration} and {introductions}. To look for a person who is not on this instance, use their full handle.",
	"onboarding.page_two.compose": "Write posts from the compose column. You can upload images, change privacy settings, and add content warnings with the icons below.",
	"onboarding.skip": "Skip",
	"privacy.change": "Adjust status privacy",
	"privacy.direct.long": "Post to targeted users only",
	"privacy.direct.short": "Direct",
	"privacy.private.long": "Post to followers only",
	"privacy.private.short": "Followers-only",
	"privacy.public.long": "Post to public timelines",
	"privacy.public.short": "Public",
	"privacy.unlisted.long": "Do not post to public timelines",
	"privacy.unlisted.short": "Unlisted",
	"reply_indicator.cancel": "Cancel",
	"report.placeholder": "Additional comments",
	"report.submit": "Submit",
	"report.target": "Reporting {target}",
	"search.placeholder": "Search",
	"search_results.total": "{count, number} {count, plural, one {result} other {results}}",
	"standalone.public_title": "A look inside...",
	"status.cannot_reblog": "This command cannot be reran",
	"status.delete": "Delete",
	"status.embed": "Embed",
	"status.favourite": "Save",
	"status.load_more": "Load more",
	"status.media_hidden": "Media hidden",
	"status.mention": "Target @{name}",
	"status.mute_conversation": "Mute conversation",
	"status.open": "Expand this status",
	"status.pin": "Pin on profile",
	"status.reblog": "Rerun",
	"status.reblogged_by": "{name} reran",
	"status.reply": "Reply",
	"status.replyAll": "Reply to thread",
	"status.report": "Report @{name}",
	"status.sensitive_toggle": "Click to view",
	"status.sensitive_warning": "Sensitive content",
	"status.share": "Share",
	"status.show_less": "Show less",
	"status.show_more": "Show more",
	"status.unmute_conversation": "Unmute conversation",
	"status.unpin": "Unpin from profile",
	"tabs_bar.compose": "Compose",
	"tabs_bar.direct": "Messages",
	"tabs_bar.federated_timeline": "Federated",
	"tabs_bar.home": "Home",
	"tabs_bar.local_timeline": "Local",
	"tabs_bar.notifications": "Notifications",
	"tools.string_rotate": "ROT13 text",
	"upload_area.title": "Drag & drop to upload",
	"upload_button.label": "Add media",
	"upload_form.undo": "Undo",
	"upload_progress.label": "Uploading...",
	"video.close": "Close video",
	"video.exit_fullscreen": "Exit full screen",
	"video.expand": "Expand video",
	"video.fullscreen": "Full screen",
	"video.hide": "Hide video",
	"video.mute": "Mute sound",
	"video.pause": "Pause",
	"video.play": "Play",
	"video.unmute": "Unmute sound",
	"video_player.expand": "Expand video",
	"video_player.toggle_sound": "Toggle sound",
	"video_player.toggle_visible": "Toggle visibility",
	"video_player.video_error": "Video could not be played"
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/mastodon/locales/en.json
// module id = 699
// module chunks = 59